import { useAuth } from '../../auth'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getQueryVariable } from '../../core/utils'
import routes from '../../routes'
import LoginLogo from '../../components/LoginLogo'
import LoginCard from '../../components/LoginCard'
import Toast from '../../components/Toast'


async function generateCodeChallenge(verifier) {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode.apply(null, new Uint8Array(digest)))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function SignIn() {
  const location = useLocation()
  const navigate = useNavigate()
  const next = location.state?.from?.pathname
  const auth = useAuth()
  const [toastMessage, setToastMessage] = useState(null);

  useEffect(() => {
    function redirect() {
      navigate(next || getQueryVariable('next') || routes.projects)
    }
    if (location.state && location.state.error) {
      let message = '알 수 없는 에러입니다. 계속될 경우 관리자에게 문의해주세요.';
      switch (location.state.error) {
        case 'auth_code_missing':
          message = '잘못된 접근입니다.'
          break;
        case 'pkce_missing':
          message = '잘못된 접근입니다.'
          break;
        case 'access_denied_for_url':
          message = '잘못된 접근입니다.'
          break;
        case 'token_exchange_failed':
          message = '접근 권한이 없습니다. 필요한 경우 관리자에게 문의해주세요.';
          break;
        default:
          break;
      }
      setToastMessage(message);
      navigate(location.pathname, { replace: true, state: {} });
    }
    if (!window.location.search && next) {
      const realNext = next === '/' ? routes.projects : next
      window.location.search = `?next=${realNext}`
    }
    if (auth.isAuthenticated) {
    auth
      .verify()
      .then((ok) => {
        if (ok) {
          redirect();
        } else {
          auth.logout(); // 실패하면 확실히 세션 초기화
        }
      })
      .catch(() => {
        auth.logout(); // verify 에러 시도 세션 날림
      });
    }
  }, [location, navigate, auth.isAuthenticated, next, auth])

  const handleToastClose = () => {
    setToastMessage(null);
  };

  async function handleLogin() {
    const provider_url = process.env.REACT_APP_OAUTH_PROVIDER_URL
    const base_url = process.env.REACT_APP_BASE_URL
    const oauthAuthorizeUrl = `${provider_url}${process.env.REACT_APP_OAUTH_AUTHORIZE_URL}`
    const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID
    const nextUrl = getQueryVariable('next')
    const redirectUri = `${base_url}${process.env.REACT_APP_REDIRECT_URL}?next=${nextUrl}`

    const codeVerifier = crypto.randomUUID();
    localStorage.setItem('pkce_code_verifier', codeVerifier);
    const codeChallenge = await generateCodeChallenge(codeVerifier);


    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: "code",
      scope: "openid profile",
      code_challenge: codeChallenge,
      code_challenge_method: "S256",
    })
    window.location.href = `${oauthAuthorizeUrl}?${params.toString()}`
  }
  return (
    <>
      <LoginCard
        cardHeader={ <LoginLogo /> }
        onButtonClick={handleLogin}
        buttonText="그룹웨어로 로그인"
      >
      </ LoginCard>
      {toastMessage && (
        <Toast
          message={toastMessage}
          type="error"
          onClose={handleToastClose}
        />
      )}
    </>
  )
}